import { Search } from '@mui/icons-material'
import { Alert, AlertTitle, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const { t } = useTranslation('common')

  const navigate = useNavigate()

  return (
    <>
      <Alert
        severity="info"
        icon={<Search sx={{ fontSize: 64 }} />}
        sx={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          p: 10,
          '& .MuiAlert-icon': {
            justifyContent: 'center',
            alignItems: 'center',
            margin: 0
          },
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }
        }}
      >
        <AlertTitle variant="h3" mb={0}>
          {t('pageNotFound')}
        </AlertTitle>
        <Button
          variant="contained"
          size="large"
          color="info"
          sx={{ mt: 6 }}
          onClick={() => navigate(-1)}
        >
          {t('back')}
        </Button>
      </Alert>
    </>
  )
}
